module.exports = __webpack_public_path__ + "img/SnapShoot.5df5bae1.png";